import type { ProductCategorySection } from "../lib/groupProductsByCategory";
import { categorySectionId } from "../lib/groupProductsByCategory";
import ProductGrid from "./ProductGrid";

export interface ProductCatalogSectionsProps {
  sections: ProductCategorySection[];
  storeSlug: string;
}

export default function ProductCatalogSections({
  sections,
  storeSlug,
}: ProductCatalogSectionsProps) {
  return (
    <div className="space-y-16">
      {sections.map(({ category, products }) => (
        <section
          key={category.id}
          id={categorySectionId(category.slug)}
          aria-labelledby={`heading-${category.slug}`}
          className="scroll-mt-28"
        >
          <h2
            id={`heading-${category.slug}`}
            className="text-2xl font-light tracking-tight text-primary-900 dark:text-white mb-8 pb-4 border-b border-primary-200 dark:border-primary-800"
          >
            {category.name}
          </h2>
          <ProductGrid products={products} storeSlug={storeSlug} />
        </section>
      ))}
    </div>
  );
}
